export enum eEscrowTypes {
  PaymentManagerAutomatedWires = 'wireDisbursements',
  PaymentManagerAutomatedACHPush = 'achPushDisbursements',
  InternalTransfer = 'restrictedInternalTransfers',
  ManualCheck = 'manualCheckDisbursements',
}
